import moment from 'moment';
import { useNavigate } from 'react-router-dom';

import { EORIGIN_DATE_FORMAT_WITH_TIME, Forwarder } from '@e-origin/shared';

import { viewIcon } from '@assets';
import { TableActions, TableColumnProps } from '@components';
import { ForwarderStatusIndicator } from './ForwarderStatusIndicator';

export const useForwarderListColumns = () => {
  const navigate = useNavigate();
  const commonActions = (row: Forwarder) => {
    return [
      {
        icon: viewIcon,
        text: 'View details',
        onClick: () => {
          navigate(`/forwarders/${row._id}`);
        },
      },
    ];
  };

  const buildColumns = (): TableColumnProps<Forwarder>[] => [
    {
      name: 'Status',
      width: '10%',
      cell: (row) => (
        <div className="whitespace-nowrap overflow-hidden overflow-ellipsis">
          <ForwarderStatusIndicator status={row.status} />
        </div>
      ),
    },
    {
      name: 'Forwarder Name',
      width: '20%',
      cell: (row) => <div className="whitespace-nowrap overflow-hidden overflow-ellipsis">{row.name}</div>,
    },
    {
      name: 'EORI number',
      width: '20%',
      cell: (row) => <div className="whitespace-nowrap overflow-hidden overflow-ellipsis">{row.eori?.number}</div>,
    },
    {
      name: 'VAT number',
      width: '20%',
      cell: (row) => <div className="whitespace-nowrap overflow-hidden overflow-ellipsis">{row.vat?.number}</div>,
    },
    {
      name: 'Date of last update',
      width: '20%',
      cell: (row) => <div className="whitespace-nowrap overflow-hidden overflow-ellipsis">{moment(row.updatedAt).format(EORIGIN_DATE_FORMAT_WITH_TIME)}</div>,
    },
    {
      name: 'Actions',
      sticky: 'right',
      cell: (row) => <TableActions actions={[...commonActions(row)]} secondaryActions={[]} disableAfterClick={true} />,
    },
  ];

  return buildColumns();
};
